import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Profile, Toast } from "../../Components";
import CardRates from "./Card/CardRates";
import ModalRates from "./ModalRates";
import { AnimatePresence } from "framer-motion";
import ModalConnect from "./ModalConnect";
import ModalAuth from "./ModalAuth";
import ModalConfirm from "./ModalConfirm";
import { influencerService } from "../../Services";

export default function Rates(props) {
  const [fcbkModul, setFcbkModul] = useState([]);
  const [instModul, setInstModul] = useState([]);
  const [tiktokModul, setTiktokModul] = useState([]);
  const [youtubeModul, setyoutubeModul] = useState([]);
  const [toastList, setToastList] = useState([]);
  const [modal, setModal] = useState(null);
  const [modalData, setModalData] = useState(null);
  const [profileType, setprofileType] = useState(null);
  const [newAccounts, setNewAccounts] = useState([]);
  const [authorizeType, setAuthorizeType] = useState("");
  const [deleteId, setDeleteId] = useState("");
  const [deleteSocialType, setDeleteSocialType] = useState("");
  const [deleteSocialId, setDeleteSocialId] = useState("");
  const [fbLink, setFbLink] = useState("");
  const [instaLink, setInstaLink] = useState("");
  const [instaLinkViaFb, setInstaLinkViaFb] = useState("");
  const [tiktokLink, setTiktokLink] = useState("");
  const [googleLink, setGoogleLink] = useState("");

  const [searchParams, setSearchParams] = useSearchParams();
  const socialId = searchParams.get("isSocial")
    ? searchParams.get("isSocial")
    : null;

  const socialErr = searchParams.get("error") ? searchParams.get("error") : 0;
  const isNew = socialId != null ? true : false;

  const deleteConfirm = (id, type, socialmediaId) => {
    setDeleteId(id);
    setDeleteSocialType(type);
    setDeleteSocialId(socialmediaId);
    setModal("confirm");
  };

  const deleteCard = () => {
    if (deleteSocialType === "facebook") {
      deleteFacebookCard(deleteId, deleteSocialId);
    }
    if (deleteSocialType === "instagram") {
      deleteInstagramCard(deleteId, deleteSocialId);
    }
    if (deleteSocialType === "tiktok") {
      deleteTiktokCard(deleteId, deleteSocialId);
    }
    if (deleteSocialType === "google") {
      deleteGoogleCard(deleteId, deleteSocialId);
    }
  };
  const deleteFacebookCard = (id, deleteSocialId) => {
    setFcbkModul(fcbkModul.filter((item) => item.pt_user_id !== id));
    removeAccount(id, deleteSocialId);
    setModal(null);
  };
  const deleteTiktokCard = (id, deleteSocialId) => {
    setTiktokModul(tiktokModul.filter((item) => item.pt_user_id !== id));
    removeAccount(id, deleteSocialId);
    setModal(null);
  };

  const deleteGoogleCard = (id, deleteSocialId) => {
    setyoutubeModul(youtubeModul.filter((item) => item.pt_user_id !== id));
    removeAccount(id, deleteSocialId);
    setModal(null);
  };

  const deleteInstagramCard = (id, deleteSocialId) => {
    setInstModul(instModul.filter((item) => item.pt_user_id !== id));
    removeAccount(id, deleteSocialId);
    setModal(null);
  };
  const addToast = (data) => {
    const newToastList = [...toastList];
    const errorMsg = data.msg instanceof Error ? data.msg.message : data.msg;
    const errorText =
      data.errorText instanceof Error ? data.errorText.message : data.errorText;
    newToastList.push({
      ...data,
      msg: errorMsg,
      errorText: errorText,
      id: `${Date.now()}-${toastList.length}`,
    });
    setToastList(newToastList);
  };
  useEffect(() => {
    if (modal) {
      document.body.classList.add("active");
    } else {
      document.body.classList.remove("active");
    }
  }, [modal]);

  const fetchAccounts = async () => {
    try {
      const [getRateRes, mediaRes] = await Promise.all([
        influencerService.getRateDetails(),
        influencerService.getUserSocialMedia(),
      ]);
      console.log("🚀 ~ fetchAccounts ~ mediaRes:", mediaRes);

      const resp = getRateRes.data;
      console.log("🚀 ~ fetchAccounts ~ resp:", resp);

      // Set social media connect links from mediaRes
      const fbPlatform = mediaRes?.data?.find((item) => item?.code === "FB");
      const instaPlatform = mediaRes?.data?.find((item) => item?.code === "IG");
      const tiktokPlatform = mediaRes?.data?.find(
        (item) => item?.code === "TT"
      );
      const youtubePlatform = mediaRes?.data?.find(
        (item) => item?.code === "YT"
      );

      setFbLink(fbPlatform?.connect_link || "");
      setInstaLink(instaPlatform?.connect_link || "");
      setInstaLinkViaFb(instaPlatform?.connect_link_via_fb || "");
      setTiktokLink(tiktokPlatform?.connect_link || "");
      setGoogleLink(youtubePlatform?.connect_link || "");

      if (getRateRes?.success === true && resp?.length > 0) {
        // Filter accounts by social media code and add products array
        const fbAccounts = resp
          .filter((item) => item?.social_media_code === "FB")
          .map((item) => ({ ...item, products: [] }));

        const igAccounts = resp
          .filter((item) => item?.social_media_code === "IG")
          .map((item) => ({ ...item, products: [] }));

        const ttAccounts = resp
          .filter((item) => item?.social_media_code === "TT")
          .map((item) => ({ ...item, products: [] }));

        const ytAccounts = resp
          .filter((item) => item?.social_media_code === "YT")
          .map((item) => ({ ...item, products: [] }));

        setFcbkModul(fbAccounts);
        setInstModul(igAccounts);
        setTiktokModul(ttAccounts);
        setyoutubeModul(ytAccounts);

        // Fetch rates for each account
        const allAccounts = [
          ...fbAccounts,
          ...igAccounts,
          ...ttAccounts,
          ...ytAccounts,
        ];

        if (allAccounts.length > 0) {
          const accountsWithRates = await Promise.all(
            allAccounts.map(async (account) => {
              try {
                const rateRes = await influencerService.getRate(
                  account.pt_user_id,
                  account.social_media_code
                );
                console.log(
                  `Rates for ${account.social_media_code} account ${account.pt_user_id}:`,
                  rateRes
                );
                return { ...account, products: rateRes?.data || [] };
              } catch (error) {
                console.error(
                  `Failed to fetch rates for account ${account.pt_user_id}:`,
                  error
                );
                return { ...account, products: [] };
              }
            })
          );
          console.log(
            "🚀 ~ fetchAccounts ~ accountsWithRates:",
            accountsWithRates
          );

          // Update state with rates
          const fbWithRates = accountsWithRates.filter(
            (item) => item.social_media_code === "FB"
          );
          const igWithRates = accountsWithRates.filter(
            (item) => item.social_media_code === "IG"
          );
          const ttWithRates = accountsWithRates.filter(
            (item) => item.social_media_code === "TT"
          );
          const ytWithRates = accountsWithRates.filter(
            (item) => item.social_media_code === "YT"
          );

          setFcbkModul(fbWithRates);
          setInstModul(igWithRates);
          setTiktokModul(ttWithRates);
          setyoutubeModul(ytWithRates);
        }
      } else {
        // No data available, set empty arrays
        setFcbkModul([]);
        setInstModul([]);
        setTiktokModul([]);
        setyoutubeModul([]);
      }
    } catch (err) {
      console.error("Fetch accounts error:", err);
      // addToast({
      //   error: true,
      //   msg: err?.message || "Failed to load accounts",
      //   date: new Date(),
      // });
    }
  };

  const fetchNewAccounts = async () => {
    try {
      const res = await influencerService.getSocialAccountsToConnect(socialId);
      console.log("🚀 ~ fetchNewAccounts ~ res:", res);
      setNewAccounts(res);
      setModal("connect");
    } catch (err) {
      console.error("Fetch new accounts error:", err);
      addToast({
        error: true,
        errorText: err?.message || "Failed to load new accounts",
        successText: "",
        date: new Date(),
      });
    }
  };

  useEffect(() => {
    fetchAccounts();
    if (isNew && socialErr === 0) {
      console.log("fffff///");
      fetchNewAccounts();
    }
    if (socialErr === 1) {
      addToast({
        error: true,
        errorText: "Error.",
        successText: "Account is already linked with another user.",
        msg: "Account is already linked with another user.",
        date: new Date(),
      });
    }
  }, []);

  const removeAccount = async (id, deletedsocialId) => {
    try {
      let param = {
        pt_user_id: id,
        social_media_id: deletedsocialId,
        status: 0,
      };
      const res = await influencerService.unlinkSocialAccount(param);
      addToast({
        error: false,
        errorText: "Error.",
        successText: "Account removed successfully.",
        msg: res["message"],
        date: new Date(),
      });
    } catch (err) {
      console.error("Remove account error:", err);
      addToast({
        error: true,
        errorText: err?.message || "Failed to remove account",
        successText: "",
        date: new Date(),
      });
    }
  };

  const saveProduct = async (data) => {
    console.log("on save product", data);
    const payload = {
      type: "r",
      platform: data.platform,
      platform_user_id: data.pt_user_id,
      product_id: data.product_id,
      rate: data.rate,
      currency: "USD",
    };
    try {
      const res = await influencerService.saveSocialAccountRateForProduct(
        payload
      );
      props.setIsBasicStepsDone(!props.isBasicStepsDone);
      addToast({
        error: false,
        errorText: "Error.",
        successText: res.message,
        msg: res.message,
        date: new Date(),
      });
    } catch (err) {
      console.error("Save product error:", err);
      addToast({
        error: true,
        errorText: err?.message || "Failed to save product",
        successText: "",
        date: new Date(),
      });
    }
  };

  const updateHandler = (data) => {
    console.log("🚀 ~ updateHandler ~ youtubeModul:", youtubeModul);
    //debugger
    if (data["type"] === "Instagram") {
      let newInsta = instModul?.map((item) => {
        if (item["pt_user_id"] === data["pt_user_id"]) {
          //debugger
          let products = item["products"].map((el) => {
            if (el["product_id"] === data["product_id"]) {
              return {
                ...el,
                rate: data["rate"],
                platform: data["typeShortName"],
                link: data["link"],
                desc: data["desc"],
              };
            } else {
              return el;
            }
          });
          console.log(products);
          return { ...item, products };
        } else {
          return item;
        }
      });

      setInstModul(newInsta);
      saveProduct(data);
    }
    if (data["type"] === "Facebook") {
      let newFb = fcbkModul.map((item) => {
        if (item["pt_user_id"] === data["pt_user_id"]) {
          //debugger
          let products = item["products"].map((el) => {
            if (el["product_id"] === data["product_id"]) {
              return {
                ...el,
                rate: data["rate"],
                platform: data["typeShortName"],
                link: data["link"],
                desc: data["desc"],
              };
            } else {
              return el;
            }
          });
          console.log(products);
          return { ...item, products };
        } else {
          return item;
        }
      });
      setFcbkModul(newFb);
      saveProduct(data);
    }

    if (data["type"] === "TikTok") {
      let newtiktok = tiktokModul.map((item) => {
        if (item["pt_user_id"] === data["pt_user_id"]) {
          //debugger
          let products = item["products"].map((el) => {
            if (el["product_id"] === data["product_id"]) {
              return {
                ...el,
                rate: data["rate"],
                platform: data["typeShortName"],
                link: data["link"],
                desc: data["desc"],
              };
            } else {
              return el;
            }
          });
          console.log(products);
          return { ...item, products };
        } else {
          return item;
        }
      });
      setTiktokModul(newtiktok);
      saveProduct(data);
    }

    if (data["type"] === "Youtube") {
      let newgoogle = youtubeModul?.map((item) => {
        if (item["pt_user_id"] === data["pt_user_id"]) {
          let products = item["products"]?.map((el) => {
            if (el["product_id"] === data["product_id"]) {
              return {
                ...el,
                rate: data["rate"],
                platform: data["typeShortName"],
                link: data["link"],
                desc: data["desc"],
              };
            } else {
              return el;
            }
          });
          return { ...item, products };
        } else {
          return item;
        }
      });
      setyoutubeModul(newgoogle);
      saveProduct(data);
    }
  };

  const authorize = (modal, type, viaFb = false) => {
    setAuthorizeType(type);
    const link =
      type === "instagram"
        ? viaFb
          ? instaLinkViaFb
          : instaLink
        : type === "facebook"
        ? fbLink
        : type === "tiktok"
        ? tiktokLink
        : googleLink;
    window.location.href = link;
  };

  const onAuthorize = () => {};

  const onSave = async (payload) => {
    console.log(payload);
    // API request to save selected handles.
    try {
      const res = await influencerService.saveSocialAccounts(payload);
      setModal(null);
      addToast({
        error: false,
        errorText: "Error.",
        successText: "Account linked successfully.",
        msg: res,
        date: new Date(),
      });
      // navigate('/influencer/social_accounts');
      fetchAccounts();
    } catch (err) {
      console.error("Save social accounts error:", err);
      addToast({
        error: true,
        errorText: err?.message || "Failed to save social accounts",
        successText: "",
        date: new Date(),
      });
    }
  };

  return (
    <>
      <div className="main">
        <div className="main__inner">
          <div className="grid sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-3 gap-4">
            {/* <div className=""> */}
            <div className="">
              <div className="rate__account">
                <div className="rate__account-title">
                  <div className="rate__account-image">
                    <img
                      src={process.env.PUBLIC_URL + "/images/facebook.png"}
                      alt="facebook"
                    />
                  </div>
                  <h3 className="big">Facebook</h3>
                </div>

                <button
                  className="button secondary"
                  onClick={() => authorize("auth", "facebook")}
                >
                  {"Link account"}
                </button>
              </div>
              {fcbkModul.length > 0 && (
                <div className="mt-4">
                  {fcbkModul.map((item, index) => {
                    return (
                      <CardRates
                        type="rates"
                        typeName="Facebook"
                        setModal={setModal}
                        typeShortName="FB"
                        setModalData={setModalData}
                        index={index}
                        key={index}
                        setprofileType={setprofileType}
                        deleteCard={() =>
                          deleteConfirm(
                            item.pt_user_id,
                            "facebook",
                            item.social_media_id
                          )
                        }
                        {...item}
                      />
                    );
                  })}
                </div>
              )}
            </div>
            <div className="">
              <div className="rate__account">
                <div className="rate__account-title">
                  <div className="rate__account-image">
                    <img
                      src={process.env.PUBLIC_URL + "/images/instagram.png"}
                      alt="instagram"
                    />
                  </div>
                  <h3 className="big">Instagram</h3>
                </div>
                <div className="flex gap-2">
                  <button
                    className="button secondary !items-center"
                    onClick={() => authorize("auth", "instagram")}
                  >
                    {"Link account"}
                  </button>
                  <button
                    className="button secondary !items-center"
                    onClick={() => authorize("auth", "instagram", true)}
                  >
                    <span className="flex flex-wrap gap-1 !justify-center">
                      {"Link account via"}
                      <img
                        className="!w-4 !h-4 !p-0"
                        src={process.env.PUBLIC_URL + "/images/facebook.png"}
                        alt="facebook"
                      />
                    </span>
                  </button>
                </div>
              </div>
              {instModul.length > 0 && (
                <div className="mt-4">
                  {instModul.map((item, index) => {
                    return (
                      <CardRates
                        type="rates"
                        typeName="Instagram"
                        typeShortName="IG"
                        setModal={setModal}
                        setModalData={setModalData}
                        index={index}
                        key={index}
                        setprofileType={setprofileType}
                        deleteCard={() =>
                          deleteConfirm(
                            item.pt_user_id,
                            "instagram",
                            item.social_media_id
                          )
                        }
                        {...item}
                      />
                    );
                  })}
                </div>
              )}
            </div>
            <div className="">
              <div className="rate__account">
                <div className="rate__account-title">
                  <div className="rate__account-image">
                    <img
                      src={process.env.PUBLIC_URL + "/images/tiktok.png"}
                      alt="tikTok"
                    />
                  </div>
                  <h3 className="big">TikTok</h3>
                </div>

                <button
                  className="button secondary"
                  onClick={() => authorize("auth", "tiktok")}
                >
                  {"Link account"}
                </button>
              </div>
              {tiktokModul.length > 0 && (
                <div className="mt-4">
                  {tiktokModul.map((item, index) => {
                    return (
                      <CardRates
                        type="rates"
                        typeShortName="TT"
                        typeName="TikTok"
                        setModal={setModal}
                        setModalData={setModalData}
                        index={index}
                        key={index}
                        setprofileType={setprofileType}
                        deleteCard={() =>
                          deleteConfirm(
                            item.pt_user_id,
                            "tiktok",
                            item.social_media_id
                          )
                        }
                        {...item}
                      />
                    );
                  })}
                </div>
              )}
            </div>
            <div className="">
              <div className="rate__account">
                <div className="rate__account-title">
                  <div className="rate__account-image">
                    <img
                      src={process.env.PUBLIC_URL + "/images/youtube.png"}
                      alt="youtube"
                    />
                  </div>
                  <h3 className="big">Youtube</h3>
                </div>
                <button
                  className="button secondary"
                  onClick={() => authorize("auth", "google")}
                >
                  {"Link account"}
                </button>
              </div>
              {youtubeModul.length > 0 && (
                <div className="mt-4">
                  {youtubeModul.map((item, index) => {
                    return (
                      <CardRates
                        type="rates"
                        typeName="Youtube"
                        typeShortName="YT"
                        setModal={setModal}
                        setModalData={setModalData}
                        index={index}
                        key={index}
                        setprofileType={setprofileType}
                        deleteCard={() =>
                          deleteConfirm(
                            item.pt_user_id,
                            "google",
                            item.social_media_id
                          )
                        }
                        {...item}
                      />
                    );
                  })}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <AnimatePresence>
        {modal === "rate" && (
          <ModalRates
            addToast={addToast}
            type={profileType}
            modalData={modalData}
            close={() => setModal(null)}
            updateHandler={updateHandler}
          />
        )}
        {modal === "connect" && (
          <ModalConnect
            close={() => setModal(null)}
            accounts={newAccounts}
            onSave={onSave}
          />
        )}
        {modal === "auth" && (
          <ModalAuth
            setModal={setModal}
            close={() => setModal(null)}
            onAuthorize={onAuthorize}
          />
        )}
        {modal === "confirm" && (
          <ModalConfirm
            setModal={setModal}
            close={() => setModal(null)}
            onConfirm={deleteCard}
          />
        )}
      </AnimatePresence>
      {toastList && (
        <Toast type="rate" list={toastList} setList={setToastList} />
      )}
    </>
  );
}
